@if (results.length) {
    <div class="results">
        @for (result of results | slice:0:position; track result) {
            <fui-deprecated-autocomplete-control-result [result]="result">
                <ng-template #autocompletecontrolresult let-result="result">
                    <ng-container [ngTemplateOutlet]="autocompleteControlResult"
                                  [ngTemplateOutletContext]="$any({result: result})"></ng-container>
                </ng-template>
            </fui-deprecated-autocomplete-control-result>
        }
        @if (hasShowMore()) {
            <div class="footer">
                <fui-local-button class="outline utility color-chewzie-primary" (click)="showMore()"
                                  [title]="'fui.common.button.loadMore'"></fui-local-button>
            </div>
        }
    </div>
}
@if (!results.length) {
    <div class="message">
        <fui-empty [description]="'fui.autocomplete-control.message.noResultsDescription'"
                   [title]="'fui.autocomplete-control.message.noResultsTitle'">
            <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
        </fui-empty>
    </div>
}
